module.exports = __webpack_public_path__ + "img/img_2.bc7b5a0c.png";